import { getAllRecords, getRecord, putRecord, deleteRecord } from "./db";
import { isTripWorkspace, type TripWorkspace } from "@japangolmok/core";
type TrashedTrip = { id: string; trip: TripWorkspace; deletedAt: string };
// Write the recovery copy first; a failed second phase preserves the original and the recovery copy.
export async function trashTrip(trip: TripWorkspace) {
	if (!isTripWorkspace(trip)) throw new Error("INVALID_TRIP");
	await putRecord("trash", {
		id: trip.id,
		trip,
		deletedAt: new Date().toISOString(),
	});
	await deleteRecord("trips", trip.id);
}
export async function recentTrash() {
	const rows = await getAllRecords<TrashedTrip>("trash");
	for (const row of rows.filter(
		(x) =>
			isTripWorkspace(x.trip) &&
			Date.now() - Date.parse(x.deletedAt) >= 7 * 86400000,
	))
		await deleteRecord("trash", row.id);
	return rows.filter(
		(x) =>
			isTripWorkspace(x.trip) &&
			Date.now() - Date.parse(x.deletedAt) < 7 * 86400000,
	);
}
export async function restoreTrash(id: string) {
	const row = await getRecord<TrashedTrip>("trash", id);
	if (
		!row ||
		!isTripWorkspace(row.trip) ||
		Date.now() - Date.parse(row.deletedAt) >= 7 * 86400000
	)
		throw new Error("RESTORE_FAILED");
	if (await getRecord("trips", id)) throw new Error("TRIP_EXISTS");
	await putRecord("trips", row.trip);
	await deleteRecord("trash", id);
}
